import { Tabs } from 'antd';
import type { TabsProps } from 'antd';
import AppList from './appList';
import './index.less';

const AppBinding = () => {
  // tabs
  const tabItems: TabsProps['items'] = [
    {
      key: 'independentAppList',
      label: `独立小程序`,
      children: <AppList appType={0} />,
    },
    {
      key: 'projectAppList',
      label: `项目小程序`,
      children: <AppList appType={1} />,
    },
  ];

  return (
    <div>
      <Tabs className="tabContainer" defaultActiveKey="independentAppList" items={tabItems} />
    </div>
  );
};
export default AppBinding;
